// Bus local para reutilizar el unico EventSource del inbox. useWhatsAppChat
// recibe el SSE del proveedor y useWhatsAppCall consume solo los estados de la
// llamada activa, sin abrir otra conexion ni hacer polling.
const listeners = new Set();

export function publishWhatsAppCallEvent(event) {
  for (const listener of listeners) {
    try { listener(event); } catch (_) { /* un consumidor no rompe a los demas */ }
  }
}

export function subscribeWhatsAppCallEvents(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
